"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var unavailable_exports = {};
__export(unavailable_exports, {
  ProtectedStore: () => ProtectedStore
});
module.exports = __toCommonJS(unavailable_exports);
var import_nativeError = require("../nativeError");
var ProtectedStore = Object.freeze({
  createItem: function createItem(_key, _value, _policy) {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("ProtectedStore.createItem"));
  },
  getItem: function getItem(_key, _reason, _policy) {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("ProtectedStore.getItem"));
  },
  updateItem: function updateItem(_key, _value, _reason, _policy) {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("ProtectedStore.updateItem"));
  },
  deleteItem: function deleteItem(_key, _reason, _policy) {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("ProtectedStore.deleteItem"));
  }
});
//# sourceMappingURL=unavailable.js.map
